module.exports = __webpack_public_path__ + "static/media/01-course-overview.c3940960.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-courses-work/01-course-overview.jpg
// module id = 370
// module chunks = 0